import { render, staticRenderFns } from "./ShowAppropriateCard.vue?vue&type=template&id=2ebe36f8&scoped=true"
import script from "./ShowAppropriateCard.vue?vue&type=script&lang=js"
export * from "./ShowAppropriateCard.vue?vue&type=script&lang=js"
import style0 from "./ShowAppropriateCard.vue?vue&type=style&index=0&id=2ebe36f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe36f8",
  null
  
)

export default component.exports